export default {
  EDIT: 'EDIT',
  // VIEW: 'VIEW',
  CREATE: 'CREATE'
};
